var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationPointRhombic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3135,
    width: 16,
    height: 16,
    rx: 2,
    transform: "rotate(45 11.3135 0)",
    fill: "#EC1C3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.8438C10.6562 13.8438 10 14.5 10 15.2969C10 16.0938 10.6562 16.75 11.5 16.75C12.2969 16.75 12.9531 16.0938 12.9531 15.2969C12.9531 14.5 12.2969 13.8438 11.5 13.8438ZM10.375 6.625V11.125C10.375 11.7812 10.8438 12.25 11.5 12.25C12.1094 12.25 12.625 11.7812 12.625 11.125V6.625C12.625 6.01562 12.1094 5.5 11.5 5.5C10.8438 5.5 10.375 6.01562 10.375 6.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPointRhombic);
export default __webpack_public_path__ + "static/media/exclamation-point-rhombic.6d64fc323c956d5ef1efa9ede0e5f017.svg";
export { ForwardRef as ReactComponent };